import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import ErrorScreen from './components/ErrorScreen.jsx';
import { initNative } from './native.js';
import { initSentry, Sentry } from './sentry.js';
import './styles.css';

initSentry();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={({ resetError }) => <ErrorScreen resetError={resetError} />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);

initNative();
